/**
 * Site top navigation
 * **/
const topNavigation = [{
  hint: 'My Portoflio',
  to: 'https://wemakesites.net/',
  icon: 'mdi-home'
}, {
  hint: 'BitBucket Repo',
  to: 'https://bitbucket.org/acidmartin/vc-image-placeholder',
  icon: 'mdi-bitbucket'
}, {
  hint: 'vc-image-placeholder@npm',
  to: 'https://npmjs.com/package/vc-image-placeholder',
  icon: 'mdi-npm'
}, {
  hint: 'My Blog',
  to: 'https://martinivanov.net/',
  icon: 'mdi-wordpress'
}, {
  hint: 'Contact me',
  to: 'https://wemakesites.net/contact',
  icon: 'mdi-email'
}]

export default topNavigation



// WEBPACK FOOTER //
// ./src/helpers/top-navigation.js